import { Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import { Input } from "@mui/material";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  checkPostcode,
  getDeliveryInfo,
} from "../../services/delivery/actions.js";

function DeliveryOptions(props) {
  const [postCode, setPostcode] = useState(null);
  const [postCodeCorrect, setPostcodeCorrect] = useState(false);
  const [postCodeMessage, setPostcodeMessage] = useState(null);
  const [houseNumber, setHouseNumber] = useState(null);
  const [deliveryData, setDeliveryData] = useState(null);
  const [chosenDate, setChosenDate] = useState(null);
  const [checked, setChecked] = useState(null);
  const [addressLine, setAddressLine] = useState(null);
  const [addressData, setAddressData] = useState(null);

  const resetState = () => {
    setPostcodeCorrect(false);
    setDeliveryData(null);
    setPostcodeMessage(null);
    setChosenDate(null);
    setChecked(null);
  };

  const handleHouseNumber = (value) => {
    if (value.length > 5) {
      return;
    }
    setHouseNumber(value);
  };
  useEffect(() => {
    if (postCodeCorrect) {
      getDeliveryInfo(props.currentLocation.id, setDeliveryData);
    }
  }, [postCodeCorrect]);

  useEffect(() => {
    if (addressData) {
      let data = {
        chosenDate: chosenDate,
        postCode: postCode,
        houseNumber: houseNumber,
        street: addressData.street,
        city: addressData.city,
      };
      props.setChosenDeliveryOption(data);
    }
  }, [chosenDate]);

  useEffect(() => {
    if (!checked) {
      props.readyToPlaceOrder(false);
    }
  }, [checked]);

  return (
    <div>
      <Typography style={{ fontWeight: "bold" }}>
        Voer uw postcode en huisnummer in:
      </Typography>
      <div style={{ justifyContent: "space-between" }}>
        <Input
          sx={{
            width: "70px",
            marginRight: 5,
          }}
          value={postCode}
          placeholder="1111AB"
          inputProps={{ maxLength: 6 }}
          onChange={(event) => setPostcode(event.target.value)}
        />
        <Input
          sx={{ width: "70px" }}
          value={houseNumber}
          placeholder="11"
          type="number"
          onChange={(event) => handleHouseNumber(event.target.value)}
        />
      </div>
      <br />
      <Typography style={{ color: "green" }}>
        {addressLine ? addressLine : null}
      </Typography>
      <br />
      <Button
        style={{
          height: "40px",
          width: "150px",
          fontSize: "12px",
          marginRight: "5px",
          marginLeft: "5px",
          marginBottom: "15px",
          fontWeight: "bold",
        }}
        color="primary"
        variant="contained"
        onClick={() => {
          resetState();
          checkPostcode(
            postCode,
            houseNumber,
            true,
            setPostcodeCorrect,
            setAddressLine,
            setAddressData,
            setPostcodeMessage
          );
        }}
      >
        Check!
      </Button>
      <Typography style={{ fontWeight: "bold" }}>
        {postCodeMessage ? postCodeMessage : null}
      </Typography>

      {deliveryData?.delivery_days ? (
        <FormControl component="fieldset">
          <RadioGroup
            aria-label="gender"
            name="gender1"
            value={chosenDate}
            onChange={(event) => setChosenDate(event.target.value)}
            align="center"
          >
            {deliveryData.delivery_days.map((deliveryOption) => (
              <FormControlLabel
                value={
                  deliveryOption.date +
                  ";" +
                  deliveryOption.from +
                  ";" +
                  deliveryOption.until +
                  ";" +
                  deliveryData.delivery_costs
                }
                control={<Radio color="primary" />}
                label={
                  deliveryOption.name_of_day +
                  " " +
                  deliveryOption.date +
                  ": " +
                  deliveryOption.from +
                  "-" +
                  deliveryOption.until
                }
              />
            ))}
          </RadioGroup>
        </FormControl>
      ) : null}
      {chosenDate ? (
        <FormControlLabel
          control={
            <Checkbox
              color="primary"
              checked={checked}
              onChange={() => setChecked(!checked)}
              inputProps={{ "aria-label": "primary checkbox" }}
            />
          }
          label="Bevestig uw afleverdatum"
        />
      ) : null}
      {checked ? (
        <Button
          color="primary"
          variant="contained"
          onClick={() => props.readyToPlaceOrder(true)}
        >
          Volgende stap
        </Button>
      ) : null}
    </div>
  );
}

function mapStateToProps(state) {
  return {
    currentLocation: state.currentInformation.current_location,
  };
}

export default connect(mapStateToProps)(DeliveryOptions);
